// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"bW-z","inlineTitle":"cW-z","sponsoredAdsWrapper":"dW-z","marketplaceRecosWrapper":"eW-z"};